const styles = (theme) => ({
  aboutProfileWrapper: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(9),
      paddingBottom: theme.spacing(9),
    },
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    "& .aboutProfile": {
      borderRadius: 8,
      boxShadow: "0 23px 42px 0 rgba(106, 118, 154, 0.15)",
      display: "flex",
      padding: theme.spacing(4),
      [theme.breakpoints.down("sm")]: {
        display: "block",
        padding: theme.spacing(3,3,0),
      },
      [theme.breakpoints.down("xs")]: {
        display: "block",
      },
      "& .profileImg": {
        maxHeight:615,
        borderRadius:8,
        objectFit: 'cover',
        [theme.breakpoints.down("1200")]: {
          maxHeight:515,
        },
        [theme.breakpoints.down("sm")]: {
          maxHeight:415,
        },
        [theme.breakpoints.down("xs")]: {
          maxHeight:"unset",
          width:'100%',
        },
      },
      "& .profileDetails": {
        display:'flex',
        flexDirection:"column",
        flex: 1,
        paddingLeft:theme.spacing(4),
        [theme.breakpoints.down("sm")]: {
          paddingLeft:theme.spacing(0),
          padding:theme.spacing(4,0),
        },
        [theme.breakpoints.down("xs")]: {
          padding:theme.spacing(4,0),
        },
        "& .name": {
          fontSize: 36,
          fontWeight: 900,
          lineHeight: 1.25,
          color: "#4c4c78",
          marginBottom: theme.spacing(1),
          "& h2":{
            fontSize: 36,
            margin: 0,
            [theme.breakpoints.down("sm")]: {
              fontSize: 28,
            },
            [theme.breakpoints.down("xs")]: {
              fontSize: 20,
            },
          },
        },
        "& .role": {
          fontSize: 24,
          color: "#4c4c78",
          "& p": {
            margin: 0,
            fontSize: 24,
            [theme.breakpoints.down("sm")]: {
              fontSize: 20,
            },
            [theme.breakpoints.down("xs")]: {
              fontSize: 16,
            },
          },
        },
        "& .about": {
          lineHeight: 1.78,
          color: "#4c4c78",
          marginTop: theme.spacing(4),
          marginBottom: theme.spacing(4),
          "& p": {
            margin: 0,
            fontSize:18,
            [theme.breakpoints.down("sm")]: {
              fontSize:16,
            },
            [theme.breakpoints.down("xs")]: {
              fontSize: 14,
            },
          },
        },
      },
    },
  },
});

export default styles;
